export default __webpack_public_path__ + "static/media/FlyingFrog33.ff3002d7.png";